import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../quotation/QuotationGeneral.scss";
import "react-datepicker/dist/react-datepicker.css";
import {
  CheckNull,
  CurrencyConvertion,
  formatDate,
  FormatValueDecimal,
} from "../../utils/Validate";
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DataFilter from "../../utils/DataFilter";
import DataSearch from "../../utils/DataSearch";
import FetchData, {
  DeleteEntry,
  UpdateQuotationStatus,
  GetOne,
  CreateEntry,
  GetList,
  PaginationFetchData,
} from "../../providers/dataProvider";
import UpdateStatus from "../../components/quotation/UpdateStatus";
import calculateQuoteStatistics from "../../hooks/calculateQuoteStatistics";
import ErrorMessage from "../../components/common/ErrorMessage";
import QuotationGeneralGrid from "../../components/quotation/QuotationGeneralGrid";
import QuotationGeneralFilter from "../../components/quotation/QuotationGeneralFilter";
import filterrSvg from "../.././assets/images/funnel.svg";
import ConfirmModal from "../../components/common/ConfirmModal";
import jobInHand from "../.././assets/images/jobInHand.png";
import tender from "../.././assets/images/tender.png";
import { useRolePermission } from "../../hooks/useRolePermission";
import PaginationComponent from "../../components/common/PaginationComponent";
import QuotationGeneralViewGrid from "../../components/quotation/QuotationGeneralViewGrid";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const getQuotationList = (res) => {
  const source = res?.data ?? res;
  const list = source?.payload ?? source?.data ?? source;
  return Array.isArray(list)
    ? [...list].sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0))
    : [];
};

const QuotationGeneralView = ({
  quotationSearch,
  loading: quotationLoading,
  pageNumber,
  pageSize,
  setPageNumber,
  setPageSize,
}) => {
  const location = useLocation();
  const [projectName, setProjectName] = useState("");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [quotationData, setQuotationData] = useState([]);
  const [allQuotationData, setAllQuotationData] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [clrFilter, setClrFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const [salesEng, setSalesEng] = useState([]);
  const [quotationFilter, setquotationFilter] = useState({
    customerId: null,
    salesEngineerId: null,
  });
  const [openStatus, setOpenStatus] = useState({ open: false, item: "" });
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [quoteStatistics, setQuoteStatistics] = useState({});
  const [projectCode, setprojectCode] = useState(null);
  const [quotation, setQuotation] = useState({});
  const [copyQuoteConfirm, setCopyQuoteConfirm] = useState(false);
  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });

  const navigateToForecast = () => navigate("/forecast");

  const { menuRights } = useRolePermission("Quotation");
  const { data: salesEngineerData, loading: salesEngineerLoading } = FetchData("userprofile");
  const { data: customerData, loading: customerLoading } = FetchData("Customer");
  const { data: quotationStatus, loading: quotationStatusLoading } = FetchData("quotationStatus");
  const { data: currencyList, loading: currencyLoading } = FetchData("currency");
  const { data: distributorList } = FetchData("distributor");
  const userId = localStorage.getItem("authidentity")
  const [quotationDataList, setQuotationDataList] = useState([])
  const [filterDataList, setFilterDataList] = useState({
    ProjectId: "",
    UserId: "",
    SearchTerm: ""
  });
  const [searchHistory, setSearchHistory] = useState([]);
  const [showSearchHistory, setShowSearchHistory] = useState(false);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [quotations, setQuotations] = useState([]);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  // const [quotationData, setQuotationData] = useState([]);

  useEffect(() => {
    if (quotationSearch?.payload) {
      setData(quotationSearch.payload);
      setQuotations(quotationSearch.payload);
    }
  }, [quotationSearch]);

  const customerById = useMemo(
    () => new Map((customerData || []).map((item) => [item?.id, item])),
    [customerData]
  );

  const salesEngineerByIdentityId = useMemo(
    () => new Map((salesEngineerData || []).map((item) => [item?.identityId, item])),
    [salesEngineerData]
  );

  const quoteStatusById = useMemo(
    () => new Map((quotationStatus || []).map((item) => [item?.id, item])),
    [quotationStatus]
  );

  const enrichedQuotationData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    return data.map((quotationItem) => {
      const filterItem = { ...quotationItem };
      const customerValue = customerById.get(filterItem.customerId);
      const salesValue = salesEngineerByIdentityId.get(filterItem.salesEngineerId);
      const quoteStatusValue = quoteStatusById.get(filterItem.quoteStatusId);

      filterItem.customerName = customerValue?.customerName || filterItem.customerName || "";
      filterItem.salesEngineerName = salesValue
        ? `${salesValue?.firstName || ""} ${salesValue?.lastName || ""}`.trim()
        : filterItem.salesEngineerName || "";
      filterItem.quotesTypeName = filterItem?.quoteType == "1" ? "Job In Hand" : "Tender";
      filterItem.quoteStatus = quoteStatusValue?.statusDesc || filterItem.quoteStatus || "";
      return filterItem;
    });
  }, [customerById, data, quoteStatusById, salesEngineerByIdentityId]);

  useEffect(() => {
    let visibleData = DataFilter(enrichedQuotationData, quotationFilter);
    visibleData = DataSearch(visibleData, search);
    setAllQuotationData(enrichedQuotationData);
    setQuotationData(visibleData);
    setSearchHistory(visibleData);
    setQuoteStatistics(calculateQuoteStatistics(enrichedQuotationData, currencyList));
  }, [enrichedQuotationData, currencyList, quotationFilter, search]);


  useEffect(() => {
    if (quotationSearch?.payload) {
      setData(quotationSearch.payload);
      setQuotations(quotationSearch.payload);
    }
  }, [quotationSearch]);

  const currentTableData = useMemo(() => {
    return quotationData ?? [];
  }, [quotationData]);

  const paginationData = useMemo(() => ({
    totalRecords: quotationSearch?.totalRecords ?? quotationData?.length ?? 0,
    payload: currentTableData ?? [],
  }), [quotationSearch?.totalRecords, quotationData, currentTableData]);

  const handleFilterChange = (selectedOption, params) => {
    if (params === "customer") {
      setCustomer(selectedOption);
      setquotationFilter({
        ...quotationFilter,
        customerId: selectedOption?.value,
      });
    }
    if (params === "salesengineer") {
      setSalesEng(selectedOption);
      setquotationFilter({
        ...quotationFilter,
        salesEngineerId: selectedOption?.value,
      });
    }
  };

  const handleEdit = (item, status) => {
    if (item)
      navigate("/job-in-hand", {
        state: {
          row: item, id: item?.id,
          quotegeneral: location?.state,
          quoteType: item?.quoteType, status: status,
        },
      });
  };

  const navigateToJobInHand = (type) => {
    navigate("/job-in-hand", {
      state: {
        quoteType: type,
        quotegeneral: location?.state
      },
    });
  };

  const handleForecast = (item) => {
    if (item)
      navigate("/forecast", {
        state: {
          row: item, id: item?.id,
          projectCode: projectCode,
          quotegeneral: location?.state,
          currencyList: currencyList
        },
      });
  };

  const handleActivity = (item) => {
    if (menuRights?.canViewActivities !== true || !item?.id) return;
    navigate(`/quotation-activities/${encodeURIComponent(item.id)}`, {
      state: {
        quoteReference: item?.quoteReference,
        backTarget: {
          pathname: "/quotation-general",
          state: location?.state,
        },
      },
    });
  };

  //successShow
  const SuccessDoneClick = () => {
    setSuccessShow(false);
    if (
      CheckNull(createMsg?.message) == "Quotation converted to JIH successfully"
    ) {
      handleEdit(createMsg?.successData);
    } else if (
      CheckNull(createMsg?.message) == "Quotation copied successfully"
    ) {
      handleEdit(createMsg?.successData, "copy");
    }
    setCreateMsg(null);
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "You want delete this Quotation?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
    });
  };

  const handleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true,
    });
    DeleteEntry(
      "quotation",
      item,
      setCreateMsg,
      "Quotation deleted successfully",
      "Failed to delete quotation"
    );
  };

  const ClearFilter = () => {
    setquotationFilter({
      customerId: null,
      salesEngineerId: null,
    });
    setSalesEng([]);
    setCustomer([]);
    setClrFilter(true);
  };

  const RefreshList = () => {
    ClearFilter();
  };

  useEffect(() => {
    if (clrFilter === true) {
      ApplyFilter();
    }
  }, [clrFilter, quotationFilter]);

  const ApplyFilter = () => {
    let filterResult = DataFilter(allQuotationData, quotationFilter);
    filterResult = DataSearch(filterResult, search);
    setQuotationData(filterResult);
    setSearchHistory(filterResult);
    setPageNumber(1);
    setClrFilter(false);
  };

  const ApplySearch = () => {
    const filterResult = DataSearch(DataFilter(allQuotationData, quotationFilter), search);
    setQuotationData(filterResult);
    setSearchHistory(filterResult);
    setPageNumber(1);
    setShowSearchHistory(false);
    setRefreshSearch(false);
    setFilterDataList(prev => ({
      ...prev,
      SearchTerm: search
    }));
  };
  useEffect(() => {
    if (refreshSearch === true) ApplySearch();
  }, [refreshSearch]);

  const removeSearch = () => {

    setSearch("");

    setFilterDataList(prev => ({
      ...prev,
      SearchTerm: ""
    }));

    setShowSearchHistory(false);

    setRefreshSearch(true);
  };

  const handleStatusOpen = (item, selectedStatus = null) => {
    setOpenStatus({
      open: true,
      item: item,
      selectedStatus,
    });
  };

  const handleStatusClose = () => {
    setOpenStatus({
      open: false,
      item: "",
      selectedStatus: null,
    });
  };

  const handleQuotationStatusUpdate = (newStatus, statusOption = null) => {
    if (statusOption) {
      setPendingStatusChange({
        quotationId: newStatus?.quotationId,
        quoteStatusId: statusOption?.id,
        quoteStatus: statusOption?.statusDesc,
      });
    }

    UpdateQuotationStatus(
      "quotationStatusUpdate",
      newStatus,
      setCreateMsg,
      "Quotation status updated successfully",
      "Failed to update quotation Status"
    );
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  useEffect(() => {
    if (
      CheckNull(createMsg?.message) == "Quotation status updated successfully"
    ) {
      if (pendingStatusChange?.quotationId) {
        setData((currentRows) =>
          currentRows.map((row) =>
            row?.id === pendingStatusChange.quotationId
              ? {
                ...row,
                quoteStatusId: pendingStatusChange.quoteStatusId,
                quoteStatus: pendingStatusChange.quoteStatus,
              }
              : row
          )
        );
        setPendingStatusChange(null);
      }
      handleStatusClose();
      setSuccessShow(true);
    } else if (
      CheckNull(createMsg?.message) == "Quotation deleted successfully"
    ) {
      setData((currentRows) =>
        currentRows.filter((row) => row?.id !== deleteShow?.item?.id)
      );
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
      setSuccessShow(true);
    } else if (
      CheckNull(createMsg?.message) == "Quotation copied successfully" ||
      CheckNull(createMsg?.message) == "Quotation converted to JIH successfully"
    ) {
      setCopyQuoteConfirm({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
        status: "",
      });
      setSuccessShow(true);
    } else if (createMsg?.message?.errors?.length > 0) {
      setErrorShow({ show: true, errorMessage: createMsg?.message });
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
      handleStatusClose();
      setPendingStatusChange(null);
    }
  }, [createMsg]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      ApplySearch()
      setShowSearchHistory(false);

    }
  };

  const HandleCopyQuote = (item) => {
    setCopyQuoteConfirm({
      show: true,
      item: item,
      title: "You want to copy this Quotation?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
      status: "copyquote",
    });
  };

  const HandleCancelProcess = () => {
    setCopyQuoteConfirm({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
      status: "",
    });
  };

  const HandleConfirmProcess = (item) => {
    setCopyQuoteConfirm({
      ...copyQuoteConfirm,
      loading: true,
    });

    if (copyQuoteConfirm?.status === "copyquote") {
      const copyQuote = {
        quoteReference: item?.quoteReference,
        quoteType: item?.quoteType,
        createdBy: item?.createdBy,
      };
      CreateEntry(
        "quotationcopy",
        copyQuote,
        setCreateMsg,
        "Quotation copied successfully",
        "Failed to copy quotation"
      );
    } else if (copyQuoteConfirm?.status === "convertJIH") {
      const convertQuote = {
        quoteReference: item?.quoteReference,
        createdBy: item?.createdBy,
      };
      CreateEntry(
        "quoteconvertJIH",
        convertQuote,
        setCreateMsg,
        "Quotation converted to JIH successfully",
        "Failed to covert quotation"
      );
    }
  };

  const HandleConvertJIH = (item) => {
    setCopyQuoteConfirm({
      show: true,
      item: item,
      title: "You want to convert this quote to JIH?",
      textCode: "QuoteRef",
      text: item?.quoteReference,
      loading: false,
      status: "convertJIH",
    });
  };

  const handleView = (item) => {
    navigate('/view-quotation', {
      state: {
        item: item,
        quotegeneral: location?.state,
        currencyList: currencyList
      }
    })
  }
  return (
    <div className="container-fluid" id="quotationGeneralListSec">
      <div className="row quotation-list-row">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
          <QuotationGeneralViewGrid
            handleForecast={handleForecast}
            quoteStatistics={quoteStatistics}
            currentTableData={currentTableData}
            handleEdit={handleEdit}
            handleView={handleView}
            handleDelete={handleDelete}
            handleStatusOpen={handleStatusOpen}
            navigateToForecast={navigateToForecast}
            HandleCopyQuote={HandleCopyQuote}
            HandleConvertJIH={HandleConvertJIH}
            handleActivity={handleActivity}
            menuRights={menuRights}
            currencyList={currencyList}
            quotationStatus={quotationStatus}
            distributorList={distributorList}
            loading={
              quotationLoading ||
              customerLoading ||
              salesEngineerLoading ||
              quotationStatusLoading ||
              currencyLoading
            }
            searchHistory={searchHistory}
            handleQuotationStatusUpdate={handleQuotationStatusUpdate}
          />

          {(paginationData?.totalRecords ?? 0) > 0 && (
            <PaginationComponent
              moduleName="Quotation"
              count={pageSize}
              setCount={setPageSize}
              pageSize={pageSize}
              currentPage={pageNumber}
              filteredResults={paginationData}
              setCurrentPage={setPageNumber}
            />
          )}
        </div>
      </div>

      <DeleteModal
        deleteShow={deleteShow}
        handleCancelDelete={handleCancelDelete}
        handleConfirmDelete={handleConfirmDelete}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      <SaveSuccessModel
        show={successShow}
        createMsg={createMsg}
        setShow={setSuccessShow}
        SuccessDoneClick={SuccessDoneClick}
      />
      <UpdateStatus
        openStatus={openStatus}
        handleStatusClose={handleStatusClose}
        quotationStatus={quotationStatus}
        handleQuotationStatusUpdate={handleQuotationStatusUpdate}
      />
      <ConfirmModal
        confirmShow={copyQuoteConfirm}
        HandleConfirmCancel={HandleCancelProcess}
        HandleConfirmOk={HandleConfirmProcess}
      />
    </div>
  );
};

export default QuotationGeneralView;
